export function EmptyState({ title, description, icon }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-border/70 bg-transparent px-6 py-16 text-center">
      {icon ? (
        <div className="flex h-10 w-10 items-center justify-center rounded-full border border-border text-muted-foreground">
          {icon}
        </div>
      ) : null}
      <div>
        <p className="text-sm font-medium text-foreground">{title}</p>
        {description ? (
          <p className="mt-1 text-xs text-muted-foreground">{description}</p>
        ) : null}
      </div>
    </div>
  );
}
